import React from "react";
import { Quiz } from "../../../modules/academy/models";
import { QuizCard } from "./QuizCard";

export interface QuizListProps {
  quizzes?: Quiz[];
  quizScores?: Record<string, number>;
  isGuest: boolean;
  onStartQuiz?: (quizId: string) => void;
}

export function QuizList({ quizzes, quizScores, isGuest, onStartQuiz }: QuizListProps) {
  if (!quizzes || quizzes.length === 0) {
    return (
      <section className="rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700">
        <h2 className="text-lg font-semibold mb-2">Quiz</h2>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Aucun quiz defini pour ce theme pour l'instant.
        </p>
      </section>
    );
  }

  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">Quiz</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {quizzes.map((quiz) => (
          <QuizCard
            key={quiz.id}
            quiz={quiz}
            bestScore={quizScores?.[quiz.id]}
            isGuest={isGuest}
            onStartQuiz={onStartQuiz}
          />
        ))}
      </div>
    </section>
  );
}
